// NOTA: Este es un archivo base. Necesita ser completado con toda la funcionalidad de BdMovies.js
// adaptada para series. Los campos adicionales son:
// - numSeasons (número de temporadas)
// - episodesPerSeason (capítulos por temporada - formato: "10,12,8" o JSON)
// - episodeDuration (duración de cada capítulo)
// - totalEpisodes (total de capítulos)

import React, { useEffect, useState, useRef } from 'react';
import '../../css/BdStyles.css';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import Cropper from "react-cropper";
import ImageCrop from "../components/ImageCrop";
import "cropperjs/dist/cropper.css";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TagDetailModal from '../components/TagDetailModal';
import RichTextInput from '../components/RichTextInput';
import { API_BASE_URL } from '../scripts/control';
import { ROUTE_PATHS } from '../../../config/constants';
import { dataURLtoBlob } from '../../../utils/dataURLtoBlob';

const BdSeries = () => {
    const { idSeries } = useParams();
    const navigate = useNavigate();
    const { isLoggedIn, isAdmin, login, user } = useAdminAuth();
    const [series, setSeries] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [editingSeries, setEditingSeries] = useState(null);
    const [deletingSeries, setDeletingSeries] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [favorites, setFavorites] = useState({});
    const seriesPerPage = 6;
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [availableTags, setAvailableTags] = useState([]);
    const [searchFilters, setSearchFilters] = useState({
        text: '',
        numSeasons: '',
        numSeasonsComparator: '>',
        episodeDuration: '',
        episodeDurationComparator: '>',
        selectedTags: [],
    });
    const [filteredSeries, setFilteredSeries] = useState([]);
    const [showSearchOptions, setShowSearchOptions] = useState(false);
    const [editingTagDetails, setEditingTagDetails] = useState({});
    const [showTagDetailModal, setShowTagDetailModal] = useState(false);
    const [currentTagForDetail, setCurrentTagForDetail] = useState(null);
    const selectedSeries = idSeries
        ? series.find(serie => serie.idSeries === parseInt(idSeries, 10))
        : null;
    const [mediaType, setMediaType] = useState('image');
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [playingSeriesId, setPlayingSeriesId] = useState(null);
    const videoRef = useRef(null);
    const pauseTimeoutRef = useRef(null);
    const [seriesName, setSeriesName] = useState('');
    const [seriesYear, setSeriesYear] = useState('');
    const [seriesAge, setSeriesAge] = useState('');
    const [numSeasons, setNumSeasons] = useState('');
    const [episodesPerSeason, setEpisodesPerSeason] = useState('');
    const [episodeDuration, setEpisodeDuration] = useState('');
    const [totalEpisodes, setTotalEpisodes] = useState('');
    const [img_alt, setImgAlt] = useState('');
    const [img_url, setImgUrl] = useState('');
    const [video_url, setVideoUrl] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeInfo, setActiveInfo] = useState(null);
    const popoverRef = useRef(null);
    const [credits, setCredits] = useState([{ label: '', value: '' }]);
    const [articles, setArticles] = useState([{ label: '', detail: '' }]);
    const [rawImageFile, setRawImageFile] = useState(null);
    const [synopsis, setSynopsis] = useState('');
    const [structure, setStructure] = useState('');
    const [newSynopsis, setNewSynopsis] = useState('');
    const [newStructure, setNewStructure] = useState('');
    const [editSynopsis, setEditSynopsis] = useState('');
    const [editStructure, setEditStructure] = useState('');
    const [calOrg, setCalOrg] = useState('');
    const [calCriterion, setCalCriterion] = useState('');
    const [supervLevel, setSupervLevel] = useState('');
    const totalPages = Math.ceil(filteredSeries.length / seriesPerPage);

    // 1. Obtener las series y etiquetas juntas
    useEffect(() => {
        const fetchSeriesAndTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php?fetchTags=true`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                    },
                    credentials: 'omit', // No enviar cookies para evitar problemas de CORS
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
    
                if (data.series && Array.isArray(data.series)) {
                    // Convertir tags a array (manejar string, array, o valores inválidos)
                    const seriesWithArrayTags = data.series.map(serie => ({
                        ...serie,
                        tags: Array.isArray(serie.tags) 
                            ? serie.tags 
                            : (typeof serie.tags === 'string' ? serie.tags.split(', ') : [])
                    }));
                    
                    // Ordenar por fecha de creación (más recientes primero)
                    const sortedSeries = seriesWithArrayTags.sort((a, b) => {
                        if (a.created_at && b.created_at) {
                            return new Date(b.created_at) - new Date(a.created_at);
                        }
                        const idA = parseInt(a.idSeries || a.id || 0);
                        const idB = parseInt(b.idSeries || b.id || 0);
                        return idB - idA;
                    });
                    
                    setSeries(sortedSeries);
                }
    
                if (data.tags && Array.isArray(data.tags)) {
                    setTags(data.tags); 
                }
            } catch (error) {
                // Mostrar un mensaje más descriptivo al usuario
                if (error.message.includes('CORS') || error.message.includes('Failed to fetch')) {
                }
            }
        };
    
        fetchSeriesAndTags();
    }, []);

    useEffect(() => {
        // Aplica los filtros cada vez que cambian
        const applyFilters = () => {
            let filtered = [...series];
    
            // Filtrar por texto
            if (searchFilters.text) {
                const lowerText = searchFilters.text.toLowerCase();
                filtered = filtered.filter(serie =>
                    serie.seriesName.toLowerCase().includes(lowerText) ||
                    serie.seriesAge.toString().includes(lowerText) ||
                    serie.seriesYear.toString().includes(lowerText) ||
                    serie.tags.some(tag => tag.toLowerCase().includes(lowerText))
                );
            }
    
            // Filtrar por número de temporadas
            if (searchFilters.numSeasons) {
                const numSeasonsValue = Number(searchFilters.numSeasons);
                if (!isNaN(numSeasonsValue)) {
                    filtered = filtered.filter(serie =>
                        searchFilters.numSeasonsComparator === '>'
                            ? Number(serie.numSeasons) > numSeasonsValue
                            : Number(serie.numSeasons) < numSeasonsValue
                    );
                }
            }

            // Filtrar por duración de capítulo
            if (searchFilters.episodeDuration) {
                const durationValue = Number(searchFilters.episodeDuration);
                if (!isNaN(durationValue)) {
                    filtered = filtered.filter(serie =>
                        searchFilters.episodeDurationComparator === '>'
                            ? Number(serie.episodeDuration) > durationValue
                            : Number(serie.episodeDuration) < durationValue
                    );
                }
            }
    
            // Filtrar por etiquetas seleccionadas
            if (searchFilters.selectedTags.length > 0) {
                filtered = filtered.filter(serie =>
                    searchFilters.selectedTags.every(tag =>
                        serie.tags.includes(tag)
                    )
                );
            }
    
            setFilteredSeries(filtered);
        };
    
        applyFilters();
    }, [series, searchFilters]);

    useEffect(() => {
      if (!activeInfo) return;
    
      const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
          setActiveInfo(null);
        }
      };
    
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [activeInfo]);

    const handleFilterChange = (field, value) => {
        setSearchFilters(prevFilters => ({
            ...prevFilters,
            [field]: value,
        }));
    };

    useEffect(() => {
      if (currentPage > totalPages) {
        setCurrentPage(1);
      }
    }, [filteredSeries]);

    useEffect(() => {
        if (editingSeries) {
            const tagIds = editingSeries.tags.map(tagName => {
                const tag = tags.find(t => t.tagName === tagName);
                return tag ? tag.idTag : null;
            }).filter(Boolean);
            setSelectedTags(tagIds);
        }
    }, [editingSeries, tags]);

    const handleCreateNew = () => {
        setShowCreateModal(true);
    };

    const handleConfirmClose = () => {
        setEditingSeries(null);
        setShowCreateModal(null);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
    };

    const handleSaveNewSeries = async () => {
      const imgAlt = document.getElementById('img_alt').value;
      const seriesName = document.getElementById('newSeriesName').value;
      const seriesYear = document.getElementById('newSeriesYear').value.trim();
      const seriesAge = document.getElementById('newSeriesAge').value;
      const synopsis = newSynopsis;
      const structure = newStructure;
      const calOrg = document.getElementById('newCalOrg').value;
      const calCriterion = document.getElementById('newCalCriterion').value;
      const supervLevel = document.getElementById('newSupervLevel').value;
      const numSeasons = document.getElementById('newNumSeasons').value.trim();
      const episodesPerSeason = document.getElementById('newEpisodesPerSeason').value.trim();
      const episodeDuration = document.getElementById('newEpisodeDuration').value.trim();
      const totalEpisodes = document.getElementById('newTotalEpisodes').value.trim();
    
      if (!seriesName || !seriesAge) {
        alert("Por favor, completa todos los campos obligatorios (Nombre y Clasificación).");
        return;
      }
    
      const formData = new FormData();
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(selectedTags.reduce((acc, id) => {
        acc[id] = editingTagDetails[id] || "";
        return acc;
      }, {})));
      formData.append('seriesName', seriesName);
      formData.append('seriesYear', seriesYear);
      formData.append('seriesAge', seriesAge);
      formData.append('calOrg', calOrg);
      formData.append('calCriterion', calCriterion);
      formData.append('supervLevel', supervLevel);
      formData.append('numSeasons', numSeasons);
      formData.append('episodesPerSeason', episodesPerSeason);
      formData.append('episodeDuration', episodeDuration);
      formData.append('totalEpisodes', totalEpisodes);
      formData.append('synopsis', synopsis);
      formData.append('structure', structure);
      formData.append('credits', JSON.stringify(credits));
      formData.append('articles', JSON.stringify(articles));
      formData.append('img_alt', imgAlt);

      if (croppedImage) {
        formData.append('img_url', croppedImage);
      } else if (selectedVideo) {
        formData.append('video_url', selectedVideo);
      }
    
      try {
        let response;
        if (isAdmin) {
          formData.append('action', 'create');
          formData.append('contentType', 'serie');
          response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php`, {
            method: 'POST',
            body: formData,
            credentials: 'omit', // No enviar cookies para evitar problemas de CORS
          });
          if (!response.ok) {
            const errorText = await response.text();
            alert("Error al guardar la serie. Verifica la consola para más detalles.");
          } else {
            const result = await response.json();
            if (result.success) {
              alert("Serie guardada correctamente.");
              window.location.reload();
            } else {
              alert("Error al guardar la serie: " + (result.message || 'Error desconocido'));
            }
          }
        } else {
          formData.append('action', 'submit_create');
          formData.append('contentType', 'serie');
          formData.append('userId', user.id);
          response = await fetch(`${API_BASE_URL}/api/user_requests.php`, {
            method: 'POST',
            body: formData,
            credentials: 'omit',
          });
          if (!response.ok) {
            alert("Error al enviar la solicitud.");
          } else {
            alert("Solicitud enviada para su revisión.");
            window.location.reload();
          }
        }
      } catch (err) {
        if (err.message.includes('CORS') || err.message.includes('Failed to fetch')) {
          alert("Error de CORS: El servidor no está enviando los headers CORS correctamente. Verifica que el archivo PHP esté actualizado en el servidor.");
        } else {
          alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
        }
      }
    };

    const toggleFavorite = (id) => {
        setFavorites((prevFavorites) => ({
            ...prevFavorites,
            [id]: !prevFavorites[id],
        }));
    };
    
    const handleEdit = (serie) => {
      setMediaType('video');
      setEditingSeries(serie);
      setEditSynopsis(serie.synopsis || '');
      setEditStructure(serie.structure || '');
      setEditingTagDetails({ ...serie.tagsDetails });
      setSelectedVideo(null);
      if (serie.credits) {
          if (typeof serie.credits === 'string') {
            const creditItems = serie.credits
              .split('||')
              .map(item => {
                const parts = item.split('::');
                return parts.length === 2 ? { label: parts[0], value: parts[1] } : null;
              })
              .filter(item => item !== null);
            setCredits(creditItems);
          } else if (Array.isArray(serie.credits)) {
            setCredits(serie.credits);
          }
        } else {
          setCredits([]);
        }
          setShowModal(true);
          if (serie.video_url) {
            setMediaType('video');
          } else {
            setMediaType('image');
          }

      if (serie.articles) {
          if (typeof serie.articles === 'string') {
            const articleItems = serie.articles
              .split('||')
              .map(item => {
                const parts = item.split('::');
                return parts.length === 2 ? { label: parts[0], value: parts[1] } : null;
              })
              .filter(item => item !== null);
            setArticles(articleItems);
          } else if (Array.isArray(serie.articles)) {
            setArticles(serie.articles);
          }
        } else {
          setArticles([]);
        }
          setShowModal(true);
          if (serie.video_url) {
            setMediaType('video');
          } else {
            setMediaType('image');
          }
    };
    
    const handleDelete = (serie) => {
        setDeletingSeries(serie);
    };
    
    const confirmDelete = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: deletingSeries.idSeries }),
            credentials: 'omit',
        });
    
        if (response.ok) {
            setSeries(series.filter((serie) => serie.idSeries !== deletingSeries.idSeries));
            setDeletingSeries(null);
        } else {
        }
    } catch (error) {
    }
};

    const cancelDelete = () => {
        setDeletingSeries(null);
    };

    const handleSave = async () => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      const formData = new FormData();
      const seriesName = document.getElementById('seriesName').value;
      const seriesYear = document.getElementById('seriesYear').value;
      const seriesAge = document.getElementById('seriesAge').value;
      const synopsis = editSynopsis;
      const structure = editStructure;
      const calOrg = document.getElementById('calOrg').value;
      const calCriterion = document.getElementById('calCriterion').value;
      const supervLevel = document.getElementById('supervLevel').value;
      const numSeasons = document.getElementById('numSeasons').value;
      const episodesPerSeason = document.getElementById('episodesPerSeason').value;
      const episodeDuration = document.getElementById('episodeDuration').value;
      const totalEpisodes = document.getElementById('totalEpisodes').value;
      const imgAlt = document.getElementById('img_alt').value;
      
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
      
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      formData.append('idSeries', editingSeries.idSeries);
      formData.append('seriesName', seriesName);
      formData.append('seriesYear', seriesYear);
      formData.append('seriesAge', seriesAge);
      formData.append('synopsis', synopsis);
      formData.append('structure', structure);
      formData.append('calOrg', calOrg);
      formData.append('calCriterion', calCriterion);
      formData.append('supervLevel', supervLevel);
      formData.append('numSeasons', numSeasons);
      formData.append('episodesPerSeason', episodesPerSeason);
      formData.append('episodeDuration', episodeDuration);
      formData.append('totalEpisodes', totalEpisodes);
      formData.append('credits', JSON.stringify(credits));
      formData.append('articles', JSON.stringify(articles));
      
      let response;
      try {
        if (isAdmin) {
          formData.append('action', 'update');
          formData.append('contentType', 'serie');
          if (mediaType === 'image') {
              if (croppedImage) {
                const { blob, ext, isValid } = dataURLtoBlob(croppedImage);
                const filename = rawImageFile?.name || `img_${Date.now()}.${ext}`;
                if (isValid && blob.size > 0) {
                  formData.append('img_url', blob, filename);
                } else if (rawImageFile) {
                  console.warn('Conversión de imagen recortada falló, usando archivo original');
                  formData.append('img_url', rawImageFile, rawImageFile.name);
                }
              } else if (rawImageFile) {
                formData.append('img_url', rawImageFile, rawImageFile.name);
              }
            } else if (mediaType === 'video' && selectedVideo) {
            formData.append('video_url', selectedVideo, selectedVideo.name)
          }
          if (selectedVideo) {
            formData.append('video_url', selectedVideo, selectedVideo.name);
          }
          response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php`, {
            method: 'POST',
            body: formData,
            credentials: 'omit',
          });
          if (response.ok) {
            const updatedSeries = await response.json();
          } else {
          }
        } else {
          const formDataUser = new FormData();
          formDataUser.append('action', editingSeries ? 'submit_update' : 'submit_create');
          formDataUser.append('contentType', 'serie');
          formDataUser.append('target_id', editingSeries ? editingSeries.idSeries : '');
          formDataUser.append('seriesName', seriesName);
          formDataUser.append('seriesYear', seriesYear);
          formDataUser.append('seriesAge', seriesAge);
          formDataUser.append('synopsis', synopsis);
          formDataUser.append('structure', structure);
          formDataUser.append('calOrg', calOrg);
          formDataUser.append('calCriterion', calCriterion);
          formDataUser.append('supervLevel', supervLevel);
          formDataUser.append('numSeasons', numSeasons);
          formDataUser.append('episodesPerSeason', episodesPerSeason);
          formDataUser.append('episodeDuration', episodeDuration);
          formDataUser.append('totalEpisodes', totalEpisodes);
          formDataUser.append('img_alt', imgAlt);
          formDataUser.append('tags', JSON.stringify(selectedTags));
          formDataUser.append('tagDetails', JSON.stringify(tagDetailsMap));
          formDataUser.append('userId', user.id);
          
          if (mediaType === 'image') {
              if (croppedImage) {
                const { blob, ext, isValid } = dataURLtoBlob(croppedImage);
                const filename = rawImageFile?.name || `img_${Date.now()}.${ext}`;
                if (isValid && blob.size > 0) {
                  formDataUser.append('img_url', blob, filename);
                } else if (rawImageFile) {
                  console.warn('Conversión de imagen recortada falló, usando archivo original');
                  formDataUser.append('img_url', rawImageFile, rawImageFile.name);
                }
              } else if (rawImageFile) {
                formDataUser.append('img_url', rawImageFile, rawImageFile.name);
              }
            } else if (mediaType === 'video' && selectedVideo) {
              formDataUser.append('video_url', selectedVideo);
            }
          
          response = await fetch(`${API_BASE_URL}/api/user_requests.php`, {
            method: 'POST',
            body: formDataUser,
          });
        }
      } catch (error) {
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      window.location.reload();
    };

    const handleImageUpload = (e) => {
      const file = e.target.files[0]
      if (!file) return
      setRawImageFile(file)
      const reader = new FileReader()
      reader.onload = () => {
        setSelectedImage(reader.result) 
        setShowCropModal(true)
      }
      reader.readAsDataURL(file)
    }

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleCropSave = (cropped) => {
        setCroppedImage(cropped);
        setShowCropModal(false);
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastSeries = currentPage * seriesPerPage;
    const indexOfFirstSeries = indexOfLastSeries - seriesPerPage;
    const currentSeries = Array.isArray(filteredSeries)
        ? filteredSeries.slice(indexOfFirstSeries, indexOfLastSeries)
        : [];

    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleTagChange = (tagId) => {
      if (selectedTags.includes(tagId)) {
        setSelectedTags(selectedTags.filter(id => id !== tagId));
      } else {
        setSelectedTags([...selectedTags, tagId]);
      }
    };

    const handleOpenTagDetail = (tagId) => {
      const tag = tags.find(t => t.idTag === tagId);
      if (tag) {
        setCurrentTagForDetail(tag);
        setShowTagDetailModal(true);
      }
    };

    const handleSaveTagDetail = async (detail) => {
      setEditingTagDetails(prev => ({ ...prev, [currentTagForDetail.idTag]: detail }));
    
      if (editingSeries) { 
        const formData = new FormData();
        formData.append('action', 'update_tag_details');
        formData.append('idSeries', editingSeries.idSeries);
        formData.append('idTag', currentTagForDetail.idTag);
        formData.append('details', detail);
    
        try {
          const response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php`, {
            method: 'POST',
            body: formData,
            credentials: 'omit',
          });
          if (!response.ok) {
          }
        } catch (error) {
        }
      }
    };

    const clearFilters = () => {
        setSearchFilters({
            text: '',
            numSeasons: '',
            numSeasonsComparator: '>',
            episodeDuration: '',
            episodeDurationComparator: '>',
            selectedTags: [],
        });
    };

    const handleMediaUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        if (mediaType === 'image') {
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result);
            setShowCropModal(true);
          };
          reader.readAsDataURL(file);
        } else if (mediaType === 'video') {
          setSelectedVideo(file);
          setShowCropModal(false);
          setSelectedImage(null);
        }
      }
    };

    const handleVideoPlay = () => {
      if (pauseTimeoutRef.current) {
        clearTimeout(pauseTimeoutRef.current);
        pauseTimeoutRef.current = null;
      }
    };

    const handleVideoPause = () => {
      pauseTimeoutRef.current = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
        setPlayingSeriesId(null);
      }, 5000);
    };

    const handleVideoEnded = () => {
      setPlayingSeriesId(null);
    };

    const handleVideoUpload = (event) => {
      const file = event.target.files[0];
      if (!file) return;
      setSelectedVideo(file);
      setMediaType('video');
    };

    const addCredit = () => {
      setCredits([...credits, { label: '', value: '' }]);
    };

    const addArticle = () => {
      setArticles([...articles, { label: '', detail: '' }]);
    };

    const removeCredit = (index) => {
      const updatedCredits = credits.filter((_, i) => i !== index);
      setCredits(updatedCredits);
    };

    const handleCreditChange = (index, field, value) => {
      const updatedCredits = [...credits];
      updatedCredits[index][field] = value;
      setCredits(updatedCredits);
    };

    const removeArticle = (index) => {
      const updatedArticles = articles.filter((_, i) => i !== index);
      setArticles(updatedArticles);
    };

    const handleArticleChange = (index, field, value) => {
      const updatedArticles = [...articles];
      updatedArticles[index][field] = value;
      setArticles(updatedArticles);
    };

    return (
    <div className="bd">
    <div className="container">
        <h2 className="title">Series</h2>
        <hr className="small-hr" />
        <br />
        <div className="search-container">
                <button
                    className="btn btn-outline-primary mb-3"
                    onClick={() => setShowSearchOptions(!showSearchOptions)}
                >Buscar
                    <i className="bi bi-search ms-1"></i>
                </button>

                {showSearchOptions && (
                    <div className="search-options p-3 border rounded bg-white">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Buscar por texto..."
                            value={searchFilters.text}
                            onChange={(e) => handleFilterChange('text', e.target.value)}
                        />

                        <select
                            className="form-select mb-2"
                            value={searchFilters.numSeasonsComparator}
                            onChange={(e) => handleFilterChange('numSeasonsComparator', e.target.value)}
                        >
                            <option value=">">Mayor que</option>
                            <option value="<">Menor que</option>
                        </select>

                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Número de temporadas"
                            value={searchFilters.numSeasons}
                            onChange={(e) => handleFilterChange('numSeasons', e.target.value)}
                        />

                        <select
                            className="form-select mb-2"
                            value={searchFilters.episodeDurationComparator}
                            onChange={(e) => handleFilterChange('episodeDurationComparator', e.target.value)}
                        >
                            <option value=">">Mayor que</option>
                            <option value="<">Menor que</option>
                        </select>

                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Duración de capítulo (minutos)"
                            value={searchFilters.episodeDuration}
                            onChange={(e) => handleFilterChange('episodeDuration', e.target.value)}
                        />

                        <div className="tags-filter">
                            <p>Filtrar por etiquetas:</p>
                            {tags.map(tag => (
                            <div key={tag.idTag}>
                                <input
                                    type="checkbox"
                                    id={`filter-tag-${tag.idTag}`}
                                    checked={searchFilters.selectedTags.includes(tag.idTag)}
                                    onChange={(e) => {
                                        const updatedTags = e.target.checked
                                            ? [...searchFilters.selectedTags, tag.idTag]
                                            : searchFilters.selectedTags.filter(id => id !== tag.idTag);
                                        handleFilterChange('selectedTags', updatedTags);
                                    }}
                                />
                                <label htmlFor={`filter-tag-${tag.idTag}`}>{tag.tagName}</label>
                            </div>
                        ))}
                        </div>

                        <button
                            className="btn btn-primary mt-3 w-100"
                            onClick={() => setShowSearchOptions(false)}
                        >
                            Aplicar filtros
                        </button>
                        <button
                            className="btn btn-secondary mt-2 w-100"
                            onClick={clearFilters}
                        >
                            Limpiar filtros
                        </button>
                    </div>
                )}
            </div>

        {isLoggedIn && (
            <button
                onClick={handleCreateNew}
                style={{
                    marginBottom: '20px',
                    marginLeft: '25%',
                    padding: '10px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                }}
            >
                Crear nueva serie
            </button>
        )}

        <div className="row">
            {currentSeries.map((serie, index) => (
            <div key={serie.idSeries || index} className="col-md-4 mb-4">
              <div className={`card ${expanded[serie.idSeries] ? 'expanded' : ''}`}>
                <div className="media-container">
                  {serie.img_url && (
                    <img
                      src={`${API_BASE_URL}/public/uploads/images/${serie.img_url}`}
                      alt={serie.seriesName}
                      className={`media-element ${playingSeriesId === serie.idSeries ? 'image-hidden' : 'image-visible'}`}
                      loading="lazy"
                    />
                  )}
                
                  {serie.video_url && (
                    <video
                      ref={videoRef}
                      controls
                      autoPlay={playingSeriesId === serie.idSeries}
                      preload={playingSeriesId === serie.idSeries ? 'auto' : 'none'}
                      onPlay={handleVideoPlay}
                      onPause={handleVideoPause}
                      onEnded={handleVideoEnded}
                      className={`media-element ${playingSeriesId === serie.idSeries ? 'video-visible' : 'video-hidden'}`}
                    >
                      <source
                        src={`${API_BASE_URL}/public/uploads/videos/${serie.video_url}`}
                        type="video/mp4"
                      />
                      Tu navegador no soporta el elemento de video.
                    </video>
                  )}
                
                  {serie.video_url && playingSeriesId !== serie.idSeries && (
                    <button className="play-button" onClick={() => setPlayingSeriesId(serie.idSeries)}>
                      &#9658;
                    </button>
                  )}
                </div>
        <div className="card-body">
          <h5 className="card-title">{serie.seriesName}</h5>
          <p className="card-text">
            <strong>Año:</strong> {serie.seriesYear}
          </p>
          <p className="card-text">
            <strong>Clasificación:</strong> {serie.seriesAge} 
            <span
              className="info-icon"
              onClick={(e) => {
                e.stopPropagation();
                setActiveInfo(activeInfo === serie.idSeries ? null : serie.idSeries);
              }}
              style={{ marginLeft: '5px', cursor: 'pointer' }}
            >
              <i className="bi bi-info-circle"></i>
            </span>
          </p>
          {activeInfo === serie.idSeries && (serie.calOrg || serie.calCriterion || serie.supervLevel) && (
               <div ref={popoverRef} className="info-popover">
              {serie.calOrg && (
                <p>
                  <strong>Organismo:</strong> {serie.calOrg}
                </p>
              )}
              {serie.calCriterion && (
                <p>
                  <strong>Criterio:</strong> {serie.calCriterion}
                </p>
              )}
              {serie.supervLevel && (
                <p>
                  <strong>Supervisión:</strong> {serie.supervLevel}
                </p>
              )}
              </div>
            )}
          <p className="card-text">
            <strong>Temporadas:</strong> {serie.numSeasons || 'N/A'}
          </p>
          <p className="card-text">
            <strong>Duración por capítulo:</strong> {serie.episodeDuration ? `${serie.episodeDuration} min` : 'N/A'}
          </p>
          <p className="card-text">
            <strong>Total de capítulos:</strong> {serie.totalEpisodes || 'N/A'}
          </p>
          
          <p className="card-text">
            <strong>Etiquetas:</strong>{' '}
            {Array.isArray(serie.tags)
              ? serie.tags.join(', ')
              : typeof serie.tags === 'string'
              ? serie.tags.split(', ').join(', ')
              : 'Sin etiquetas'}
          </p>
          <Link to={ROUTE_PATHS.DETAIL_LINK.SERIES(serie.idSeries)} className="btn btn-primary">
            Ver Detalle
          </Link>

          <div style={{ marginTop: '10px' }}>
            {isLoggedIn && (
              <button
                onClick={() => handleEdit(serie)}
                style={{
                  marginRight: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#ffc107',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Editar
              </button>
            )}
            {isAdmin && (
              <button
                onClick={() => handleDelete(serie)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#dc3545',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  color: 'white',
                }}
              >
                Borrar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

<div className="pagination">
  <button className="page-prev" disabled={currentPage === 1} onClick={() => paginate(currentPage-1)}>Anterior</button>
  {pageNumbers.map(n => (
    <button key={n} className={`page-btn ${currentPage===n ? 'active' : ''}`} onClick={() => paginate(n)}>
      {n}
    </button>
  ))}
  <button className="page-next" disabled={currentPage === totalPages} onClick={() => paginate(currentPage+1)}>Siguiente</button>
</div>

{/* Modal de creación de serie */}
{showCreateModal && (
  <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Crear Nueva Serie</h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <label htmlFor="newSeriesName">Nombre:</label>
            <input type="text" id="newSeriesName" />

            <label htmlFor="newSeriesYear">Año:</label>
            <input type="text" id="newSeriesYear" />

            <label htmlFor="newSeriesAge">Clasificación:</label>
            <input type="text" id="newSeriesAge" />

            <label htmlFor="newCalOrg">Organismo responsable de la clasificación:</label>
            <input type="text" id="newCalOrg" />

            <label htmlFor="newCalCriterion">Justificación del criterio utilizado:</label>
            <input type="text" id="newCalCriterion" />

            <label htmlFor="newSupervLevel">Nivel de supervisión:</label>
            <select name="justification" id="newSupervLevel">
                <option value=""></option>
                <option value="Autónomo (Apto para ver sin supervisión)">Autónomo (Apto para ver sin supervisión)</option>
                <option value="Acompañado (Ideal para ver y comentar con un adulto)">Acompañado (Ideal para ver y comentar con un adulto)</option>
                <option value="Supervisión necesaria (Incluye temas sensibles)">Supervisión necesaria (Incluye temas sensibles)</option>
            </select>

            <label htmlFor="newNumSeasons">Número de temporadas:</label>
            <input type="number" id="newNumSeasons" />

            <label htmlFor="newEpisodesPerSeason">Capítulos por temporada (ej: "10,12,8" o JSON):</label>
            <input type="text" id="newEpisodesPerSeason" placeholder='Ej: "10,12,8" o {"1":10,"2":12,"3":8}' />

            <label htmlFor="newEpisodeDuration">Duración por capítulo (minutos):</label>
            <input type="number" id="newEpisodeDuration" />

            <label htmlFor="newTotalEpisodes">Total de capítulos:</label>
            <input type="number" id="newTotalEpisodes" />

            <label htmlFor="newSynopsis">Sinopsis:</label>
            <RichTextInput
              id="newSynopsis"
              initialContent={newSynopsis}
              onChange={setNewSynopsis}
              placeholder="Sinopsis..."
              style={{ minHeight: '100px' }}
            />

            <label htmlFor="newStructure">Estructura:</label>
            <RichTextInput
              id="newStructure"
              initialContent={newStructure}
              onChange={setNewStructure}
              placeholder="Estructura..."
              style={{ minHeight: '100px' }}
            />

            <div className="credits-section">
              <h4>Créditos</h4>
              {credits.map((credit, index) => (
                <div key={index} className="credit-row">
                  <input
                    type="text"
                    className="credit-label"
                    value={credit.label}
                    onChange={(e) => handleCreditChange(index, 'label', e.target.value)}
                    placeholder="Crédito:"
                  />
                  <input
                    type="text"
                    className="credit-value"
                    value={credit.value}
                    onChange={(e) => handleCreditChange(index, 'value', e.target.value)}
                    placeholder="Persona"
                  />
                  <button type="button" style={{marginLeft: -8}} onClick={() => removeCredit(index)}>
                    x
                  </button>
                </div>
              ))}
              <button type="button" onClick={addCredit}>
                Agregar crédito
              </button>
            </div>

            <div className="credits-section">
              <h4>Artículos relacionados</h4>
              {articles.map((article, index) => (
                <div key={index} className="article-row">
                  <textarea
                    type="resizable-textarea"
                    className="credit-label"
                    value={article.label}
                    onChange={(e) => handleArticleChange(index, 'label', e.target.value)}
                    placeholder="Artículo"
                  /><br></br><br></br>
                  <textarea
                    type="resizable-textarea"
                    className="credit-value"
                    value={article.detail}
                    onChange={(e) => handleArticleChange(index, 'detail', e.target.value)}
                    placeholder="detalles"
                  />
                  <button type="button" style={{marginLeft: 2}} onClick={() => removeArticle(index)}>
                    x
                  </button>
                  <br></br><br></br>
                </div>
              ))}
              <button type="button" onClick={addArticle}>
                Agregar artículo
              </button>
            </div>

            <br></br><br></br>
            <div>
              <label>Subir imagen:</label>
              <input 
                type="file" 
                accept="image/*" 
                name="img_url"
                onChange={handleImageUpload} 
              />
              {croppedImage && (
                <div className="image-preview mt-3">
                  <p>Previsualización de la imagen recortada:</p>
                  <img src={croppedImage} alt="Imagen recortada" style={{ maxWidth: '100%' }} />
                </div>
              )}
            </div>
            
            <div>
              <label>Subir video:</label>
              <input 
                type="file" 
                accept="video/*" 
                name="video_url"
                onChange={handleVideoUpload} 
              />
              {selectedVideo && (
                <div className="video-preview mt-3">
                  <p>Previsualización del video:</p>
                  <video controls style={{ maxWidth: '100%' }}>
                    <source src={URL.createObjectURL(selectedVideo)} type="video/mp4" />
                    Tu navegador no soporta el elemento de video.
                  </video>
                </div>
              )}
            </div>
            <br></br> <br></br>

            <label htmlFor="img_alt">Texto alternativo de la imagen:</label>
            <input type="text" id="img_alt" /><br /><br />

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => setShowTagsModal(true)}
            >
              Seleccionar etiquetas
            </button>
          </form>

          {showTagsModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowTagsModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {tags.map(tag => (
                      <div key={tag.idTag} className="d-flex align-items-center mb-2">
                        <input
                          type="checkbox"
                          id={`tag-${tag.idTag}`}
                          checked={selectedTags.includes(tag.idTag)}
                          onChange={() => handleTagChange(tag.idTag)}
                          className="me-2"
                        />
                        <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                          {tag.tagName}
                        </label>
                        {selectedTags.includes(tag.idTag) && (
                          <button 
                            className="btn btn-link p-0" 
                            onClick={(e) => {
                              e.preventDefault();
                              handleOpenTagDetail(tag.idTag);
                            }}
                          >
                            <i className="bi bi-gear-fill text-secondary"></i>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowTagsModal(false)}
                    >
                      Guardar selección
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
        <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseModal}
        >
            Cancelar
        </button>
        {isAdmin && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewSeries}>
            Guardar serie
          </button>
        )}
        {(!isAdmin && isLoggedIn) && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewSeries}>
            Enviar serie
          </button>
        )}
        </div>
      </div>
    </div>
  </div>
)}


        {/* Modal de edición */}
        {editingSeries && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Editar Serie</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleCloseModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <label htmlFor="seriesName">Nombre:</label>
                                <input type="text" id="seriesName" defaultValue={editingSeries.seriesName} />
                                <label htmlFor="seriesYear">Año:</label>
                                <input type="text" id="seriesYear" defaultValue={editingSeries.seriesYear} />
                                <label htmlFor="seriesAge">Clasificación:</label>
                                <input type="text" id="seriesAge" defaultValue={editingSeries.seriesAge} />
                                <label htmlFor="calOrg">Organismo responsable de la clasificación:</label>
                                <input type="text" id="calOrg" defaultValue={editingSeries.calOrg} />
                    
                                <label htmlFor="calCriterion">Justificación del criterio utilizado:</label>
                                <input type="text" id="calCriterion" defaultValue={editingSeries.calCriterion} />
                    
                                <label htmlFor="supervLevel">Nivel de supervisión:</label>
                                <select name="justification" id="supervLevel" defaultValue={editingSeries.supervLevel}>
                                    <option value=""></option>
                                    <option value="Autónomo (Apto para ver sin supervisión)">Autónomo (Apto para ver sin supervisión)</option>
                                    <option value="Acompañado (Ideal para ver y comentar con un adulto)">Acompañado (Ideal para ver y comentar con un adulto)</option>
                                    <option value="Supervisión necesaria (Incluye temas sensibles)">Supervisión necesaria (Incluye temas sensibles)</option>
                                </select>
                                <label htmlFor="numSeasons">Número de temporadas:</label>
                                <input type="number" id="numSeasons" defaultValue={editingSeries.numSeasons} />
                                <label htmlFor="episodesPerSeason">Capítulos por temporada:</label>
                                <input type="text" id="episodesPerSeason" defaultValue={editingSeries.episodesPerSeason} />
                                <label htmlFor="episodeDuration">Duración por capítulo (minutos):</label>
                                <input type="number" id="episodeDuration" defaultValue={editingSeries.episodeDuration} />
                                <label htmlFor="totalEpisodes">Total de capítulos:</label>
                                <input type="number" id="totalEpisodes" defaultValue={editingSeries.totalEpisodes} />
                                <label htmlFor="img_alt">Texto alternativo:</label>
                                <input type="text" id="img_alt" />

                                <label htmlFor="synopsis">Sinopsis:</label>
                                <RichTextInput
                                  id="synopsis"
                                  initialContent={editSynopsis}
                                  onChange={setEditSynopsis}
                                  placeholder="Sinopsis..."
                                  style={{ minHeight: '100px' }}
                                />
                                <label htmlFor="structure">Estructura:</label>
                                <RichTextInput
                                  id="structure"
                                  initialContent={editStructure}
                                  onChange={setEditStructure}
                                  placeholder="Estructura..."
                                  style={{ minHeight: '100px' }}
                                />
                                <div className="credits-section">
                                  <h4>Créditos</h4>
                                  {credits.map((credit, index) => (
                                    <div key={index} className="credit-row">
                                      <input
                                        type="text"
                                        className="credit-label"
                                        value={credit.label}
                                        onChange={(e) => handleCreditChange(index, 'label', e.target.value)}
                                        placeholder="Crédito:"
                                      />
                                      <input
                                        type="text"
                                        className="credit-value"
                                        value={credit.value}
                                        onChange={(e) => handleCreditChange(index, 'value', e.target.value)}
                                        placeholder="Persona"
                                      />
                                      <button type="button" style={{marginLeft: -8}} onClick={() => removeCredit(index)}>
                                        x
                                      </button>
                                    </div>
                                  ))}
                                  <button type="button" onClick={addCredit}>
                                    Agregar crédito
                                  </button>
                                </div>
                                <br /><br />

                                <div className="credits-section">
                                  <h4>Artículos relacionados</h4>
                                  {articles.map((article, index) => (
                                    <div key={index} className="credit-row">
                                      <input
                                        type="text"
                                        className="article-label"
                                        value={article.label}
                                        onChange={(e) => handleArticleChange(index, 'label', e.target.value)}
                                        placeholder="Artículo"
                                      />
                                      <input
                                        type="text"
                                        className="article-detail"
                                        value={article.detail}
                                        onChange={(e) => handleArticleChange(index, 'detail', e.target.value)}
                                        placeholder="Detalle"
                                      />
                                      <button type="button" style={{marginLeft: -8}} onClick={() => removeArticle(index)}>
                                        x
                                      </button>
                                    </div>
                                  ))}
                                  <button type="button" onClick={addArticle}>
                                    Agregar artículo
                                  </button>
                                </div>
                                <br /><br />
                    
                                <div>
                                  <label>Subir imagen:</label>
                                  <input 
                                    type="file" 
                                    accept="image/*" 
                                    name="img_url"
                                    onChange={handleImageUpload} 
                                  />
                                  {croppedImage && (
                                    <div className="image-preview mt-3">
                                      <p>Previsualización de la imagen recortada:</p>
                                      <img src={croppedImage} alt="Imagen recortada" style={{ maxWidth: '100%' }} />
                                    </div>
                                  )}
                                </div>
                                
                                <div>
                                  <label>Subir video:</label>
                                  <input 
                                    type="file" 
                                    accept="video/*" 
                                    name="video_url"
                                    onChange={handleVideoUpload} 
                                  />
                                  {selectedVideo && (
                                    <div className="video-preview mt-3">
                                      <p>Previsualización del video:</p>
                                      <video controls style={{ maxWidth: '100%' }}>
                                        <source src={URL.createObjectURL(selectedVideo)} type="video/mp4" />
                                        Tu navegador no soporta el elemento de video.
                                      </video>
                                    </div>
                                  )}
                                </div>
                                  <br></br> <br></br>
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                                </div>
                                <div className="modal-body">
                                    {tags.map(tag => (
                                        <div key={tag.idTag} className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                id={`tag-${tag.idTag}`}
                                                checked={selectedTags.includes(tag.idTag)}
                                                onChange={() => handleTagChange(tag.idTag)}
                                                className="me-2"
                                            />
                                            <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                                                {tag.tagName}
                                            </label>
                                            
                                            {selectedTags.includes(tag.idTag) && (
                                                <button 
                                                    className="btn btn-link p-0" 
                                                    onClick={(e) => {
                                                        e.preventDefault(); 
                                                        handleOpenTagDetail(tag.idTag)
                                                    }}
                                                >
                                                    <i className="bi bi-gear-fill text-secondary"></i>
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancelar
                                    </button>
                                    {isAdmin && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Guardar
                                    </button>
                                    )}
                                    {(!isAdmin && isLoggedIn) && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Enviar
                                    </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        {/* Modal de confirmación de cierre */}
        {showConfirmCloseModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar cierre</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Quieres cerrar la ventana? Se perderán los cambios no guardados.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                            <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de confirmación de borrado */}
        {deletingSeries && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar borrado</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={cancelDelete}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro de que deseas borrar la serie {deletingSeries.seriesName}?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={cancelDelete}>Cancelar</button>
                            <button type="button" className="btn btn-danger" onClick={confirmDelete}>Borrar</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de recorte */}
        {showCropModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Recortar Imagen</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowCropModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <ImageCrop image={selectedImage} onImageSave={handleCropSave} />
                        </div>
                    </div>
                </div>
            </div>
        )}
        {showTagDetailModal && currentTagForDetail && (
          <TagDetailModal
            tag={currentTagForDetail}
            initialDetail={editingTagDetails[currentTagForDetail.idTag] || ''}
            onSave={(detail) => {
              handleSaveTagDetail(detail);
            }}
            onClose={() => setShowTagDetailModal(false)}
          />
        )}
        </div>
    </div>
    );
};

export default BdSeries;
